// extracted by mini-css-extract-plugin
export default {"previewBadge":"QuizPreviewV2_previewBadge__U4555","emptyState":"QuizPreviewV2_emptyState__x+N5C","addQuestionsLink":"QuizPreviewV2_addQuestionsLink__d2D57"};